import React from 'react';
import { ReactComponent as MachineLearningServiceWorkspacesIcon } from './machine_learning_service_workspaces.svg';

export default props => {
    const { className, style } = props;
    return <MachineLearningServiceWorkspacesIcon className={className} style={style} aria-label='Machine Learning Service Workspaces Icon' />
}